module.exports = __webpack_public_path__ + "assets/seelinestatistics.986b0719.svg";